// extracted by mini-css-extract-plugin
module.exports = {"root":"GiftCardsAvailable_root__2zc0v","rootRtl":"GiftCardsAvailable_rootRtl__h0X0x","label":"GiftCardsAvailable_label__3wzDm","value":"GiftCardsAvailable_value__FtGgq"};